import { ElementRef, EventEmitter } from '@angular/core';
import { UserService } from '../../../../core/user/user.service';
import { JhiLanguageService } from '../../../../ng-jhipster/language';
import { JhiEventManager } from '../../../../ng-jhipster/service';
import { TranslateService } from "@ngx-translate/core";
import { FindLanguageEntityFromKeyPipe } from '../../../../shared/language/find-language-entity-from-key.pipe';
import { BaseComponent } from '../../../../shared/base.component';
import { SessionStorageService } from "ngx-webstorage";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import * as i0 from "@angular/core";
import * as i1 from "ngx-webstorage";
import * as i2 from "@ng-bootstrap/ng-bootstrap";
import * as i3 from "../../../../core/user/user.service";
import * as i4 from "../../../../ng-jhipster/language";
import * as i5 from "@ngx-translate/core";
import * as i6 from "../../../../ng-jhipster/service";
import * as i7 from "@angular/common";
import * as i8 from "@angular/material/form-field";
import * as i9 from "@angular/material/select";
import * as i10 from "@angular/material/core";
import * as i11 from "@ctrl/ngx-emoji-mart/ngx-emoji";
import * as i12 from "../../../../ng-jhipster/language/jhi-translate.directive";
import * as i13 from "@angular/material/tooltip";
const _c0 = ["addLanguageModal"];
function SessionLanguageSelectorComponent_mat_form_field_1_mat_option_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-option", 5);
    i0.ɵɵelementStart(1, "div", 6);
    i0.ɵɵelementStart(2, "div", 7);
    i0.ɵɵelement(3, "ngx-emoji", 8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 9);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const language_r3 = ctx.$implicit;
    i0.ɵɵproperty("value", language_r3);
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate1("emoji", "flag-", language_r3.flagCode, "");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", language_r3.name, " ");
} }
function SessionLanguageSelectorComponent_mat_form_field_1_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-form-field", 2);
    i0.ɵɵelementStart(1, "mat-select", 3);
    i0.ɵɵlistener("valueChange", function SessionLanguageSelectorComponent_mat_form_field_1_Template_mat_select_valueChange_1_listener($event) { i0.ɵɵrestoreView(_r5); const ctx_r4 = i0.ɵɵnextContext(); return ctx_r4.dropDownSelectedLanguages = $event; })("closed", function SessionLanguageSelectorComponent_mat_form_field_1_Template_mat_select_closed_1_listener() { i0.ɵɵrestoreView(_r5); const ctx_r6 = i0.ɵɵnextContext(); return ctx_r6.emitDropDownSelectedLanguages(); });
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵtemplate(3, SessionLanguageSelectorComponent_mat_form_field_1_mat_option_3_Template, 6, 3, "mat-option", 4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("value", ctx_r0.dropDownSelectedLanguages)("placeholder", i0.ɵɵpipeBind1(2, 3, "sessionSchedule.header.languageSelector"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r0.allSessionLanguages);
} }
function SessionLanguageSelectorComponent_div_2_div_6_Template(rf, ctx) { if (rf & 1) {
    const _r12 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 15);
    i0.ɵɵlistener("click", function SessionLanguageSelectorComponent_div_2_div_6_Template_div_click_0_listener() { const restoredCtx = i0.ɵɵrestoreView(_r12); const language_r9 = restoredCtx.$implicit; const ctx_r11 = i0.ɵɵnextContext(2); return ctx_r11.selectLanguage(language_r9); });
    i0.ɵɵelementStart(1, "div");
    i0.ɵɵelement(2, "ngx-emoji", 16);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const language_r9 = ctx.$implicit;
    const ctx_r7 = i0.ɵɵnextContext(2);
    i0.ɵɵclassMap(ctx_r7.selectedLanguages.includes(language_r9.code) ? "card-selected" : "card-unselected");
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate1("emoji", "flag-", language_r9.flagCode, "");
    i0.ɵɵproperty("matTooltip", language_r9.name)("matTooltipPosition", "above")("matTooltipClass", "tool-tip");
    i0.ɵɵadvance(1);
    i0.ɵɵclassMap(ctx_r7.selectedLanguages.includes(language_r9.code) ? "text-selected" : "text-unselected");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", language_r9.nativeName, " ");
} }
function SessionLanguageSelectorComponent_div_2_div_8_Template(rf, ctx) { if (rf & 1) {
    const _r14 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 17);
    i0.ɵɵelementStart(1, "a", 18);
    i0.ɵɵlistener("click", function SessionLanguageSelectorComponent_div_2_div_8_Template_a_click_1_listener() { i0.ɵɵrestoreView(_r14); const ctx_r13 = i0.ɵɵnextContext(2); return ctx_r13.showAllLanguages(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function SessionLanguageSelectorComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "div");
    i0.ɵɵelementStart(2, "div");
    i0.ɵɵelement(3, "h3", 10);
    i0.ɵɵelement(4, "p", 11);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 12);
    i0.ɵɵtemplate(6, SessionLanguageSelectorComponent_div_2_div_6_Template, 5, 9, "div", 13);
    i0.ɵɵpipe(7, "slice");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(8, SessionLanguageSelectorComponent_div_2_div_8_Template, 2, 0, "div", 14);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(5);
    i0.ɵɵstyleProp("grid-template-columns", ctx_r1.getGridColumnNumber());
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind3(7, 4, ctx_r1.allSessionLanguages, 0, ctx_r1.endNumber));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.showViewAllLink);
} }
export class SessionLanguageSelectorComponent extends BaseComponent {
    constructor(sessionStorage, modalService, userService, languageService, translateService, eventManager) {
        super(sessionStorage, modalService);
        this.sessionStorage = sessionStorage;
        this.modalService = modalService;
        this.userService = userService;
        this.languageService = languageService;
        this.translateService = translateService;
        this.eventManager = eventManager;
        this.onChange = new EventEmitter();
        this.onLanguagesSelected = new EventEmitter();
        this.settings = {
            badgeShowLimit: 10, maxHeight: 320,
            enableFilterSelectAll: true,
            filterSelectAllText: "",
            filterUnSelectAllText: "",
            noDataLabel: "",
            position: "",
            searchBy: [],
            searchPlaceholderText: "",
            singleSelection: false,
            primaryKey: "id",
            labelKey: "id",
            lazyLoading: true,
            enableSearchFilter: false,
            enableCheckAll: false,
            showCheckbox: true,
            text: "Session Language",
            selectAllText: 'Select all',
            unSelectAllText: 'UnSelect all',
            classes: "multi-select-dropdown",
            addNewItemOnFilter: false,
            addNewButtonText: "Add New Chapter"
        };
        this.allSessionLanguages = [];
        this.endNumber = 12;
    }
    set currentCoach(value) {
        this._currentCoach = value;
    }
    get currentCoach() {
        return this._currentCoach;
    }
    ngOnInit() {
        console.log(this.selectedLanguages);
        if (this.selectedLanguages === null || this.selectedLanguages === undefined)
            this.selectedLanguages = [];
        this.langChangeSubscription = this.translateService.onLangChange.subscribe(() => {
            this.applyDefaultLanguageFilter(true);
        });
        this.userService.getAllAvailableLanguagesByUserRegion(this.currentCoach ? this.currentCoach.id : -1).subscribe(languages => {
            languages.forEach(l => {
                let language = new FindLanguageEntityFromKeyPipe().transform(l);
                this.allSessionLanguages.push(language);
            });
            console.log(this.allSessionLanguages);
            this.applyDefaultLanguageFilter();
            this.showViewAllLink = this.allSessionLanguages.length > 12;
        });
        this.eventManager.subscribe('scheduleSessionFiltersCleared', () => {
            this.selectedLanguages = [];
        });
    }
    applyDefaultLanguageFilter(selectedLanguageChanged) {
        const currentLanguage = this.languageService.getCurrentLanguage();
        if (currentLanguage === 'nl' && !this.isMatchWithCoaches) {
            const language = this.allSessionLanguages.find(l => l.code === 'nl');
            if (language) {
                this.dropDownSelectedLanguages = [language];
                this.emitDropDownSelectedLanguages();
            }
        }
        else if (selectedLanguageChanged) { // if the user has changed the language from top menu
            this.dropDownSelectedLanguages = []; // clear language filters if any language other than NL is selected
            this.emitDropDownSelectedLanguages();
        }
    }
    emitDropDownSelectedLanguages() {
        const languages = this.dropDownSelectedLanguages.map(l => l.code);
        this.onChange.emit(languages);
        console.log(languages);
    }
    selectLanguage(language) {
        if (this.selectedLanguages.includes(language.code))
            this.selectedLanguages.splice(this.selectedLanguages.indexOf(language.code), 1);
        else
            this.selectedLanguages.push(language.code);
        this.onLanguagesSelected.emit(this.selectedLanguages);
    }
    getGridColumnNumber() {
        let result = this.windowWidth > 768 ? "auto auto auto auto" : "auto auto auto";
        if (this.allSessionLanguages.length < 4) {
            result = "auto";
            for (let i = 0; i < this.allSessionLanguages.length - 1; i++) {
                result = result + " auto";
            }
        }
        return result;
    }
    showAllLanguages() {
        this.endNumber = this.allSessionLanguages.length;
        this.showViewAllLink = false;
    }
    compareSelectedLanguages(o1, o2) {
        var _a;
        return (_a = this.selectedLanguages) === null || _a === void 0 ? void 0 : _a.includes(o1.code);
    }
    ngOnDestroy() {
        var _a, _b;
        (_a = this.langChangeSubscription) === null || _a === void 0 ? void 0 : _a.unsubscribe();
        (_b = this.eventManagerSubscription) === null || _b === void 0 ? void 0 : _b.unsubscribe();
    }
}
SessionLanguageSelectorComponent.ɵfac = function SessionLanguageSelectorComponent_Factory(t) { return new (t || SessionLanguageSelectorComponent)(i0.ɵɵdirectiveInject(i1.SessionStorageService), i0.ɵɵdirectiveInject(i2.NgbModal), i0.ɵɵdirectiveInject(i3.UserService), i0.ɵɵdirectiveInject(i4.JhiLanguageService), i0.ɵɵdirectiveInject(i5.TranslateService), i0.ɵɵdirectiveInject(i6.JhiEventManager)); };
SessionLanguageSelectorComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: SessionLanguageSelectorComponent, selectors: [["session-language-selector"]], viewQuery: function SessionLanguageSelectorComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.addLanguageModal = _t.first);
    } }, inputs: { currentCoach: "currentCoach", isMatchWithCoaches: "isMatchWithCoaches", selectedLanguages: "selectedLanguages" }, outputs: { onChange: "onChange", onLanguagesSelected: "onLanguagesSelected" }, features: [i0.ɵɵInheritDefinitionFeature], decls: 3, vars: 2, consts: [["appearance", "outline", "floatLabel", "never", "class", "language-selector", 4, "ngIf"], [4, "ngIf"], ["appearance", "outline", "floatLabel", "never", 1, "language-selector"], ["tabindex", "-1", "multiple", "", "panelClass", "schedule-session-selectors-dropdown-panel", "disableOptionCentering", "true", 3, "value", "placeholder", "valueChange", "closed"], [3, "value", 4, "ngFor", "ngForOf"], [3, "value"], [1, "row"], [1, "col-2", 2, "padding-top", "18px"], [3, "emoji"], [1, "col-10", 2, "padding-top", "12px", "padding-left", "6px"], ["jhiTranslate", "sessionTypeSelection.home.selectSessionLanguage", 1, "header"], ["jhiTranslate", "sessionTypeSelection.home.chooseMore", 1, "text"], [1, "grid-container-xl"], ["class", "card language-card m-2 d-flex justify-content-center align-items-center", 3, "class", "click", 4, "ngFor", "ngForOf"], ["class", "container p-0 d-flex justify-content-center", 4, "ngIf"], [1, "card", "language-card", "m-2", "d-flex", "justify-content-center", "align-items-center", 3, "click"], [3, "emoji", "matTooltip", "matTooltipPosition", "matTooltipClass"], [1, "container", "p-0", "d-flex", "justify-content-center"], ["jhiTranslate", "sessionTypeSelection.home.showAll", 1, "btn", "btn-link", "m-3", 3, "click"]], template: function SessionLanguageSelectorComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementContainerStart(0);
        i0.ɵɵtemplate(1, SessionLanguageSelectorComponent_mat_form_field_1_Template, 4, 5, "mat-form-field", 0);
        i0.ɵɵtemplate(2, SessionLanguageSelectorComponent_div_2_Template, 9, 8, "div", 1);
        i0.ɵɵelementContainerEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.isMatchWithCoaches);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.isMatchWithCoaches);
    } }, directives: [i7.NgIf, i8.MatFormField, i9.MatSelect, i7.NgForOf, i10.MatOption, i11.EmojiComponent, i12.JhiTranslateDirective, i13.MatTooltip], pipes: [i5.TranslatePipe, i7.SlicePipe], styles: [".grid-container-xl[_ngcontent-%COMP%]{display:grid;grid-gap:10px !important;max-width:290px !important;margin:auto}.language-card[_ngcontent-%COMP%]{height:70px !important;width:90px !important;border-radius:8px !important;border:1px solid #44a38b !important;margin-left:auto !important;margin-right:auto !important;cursor:pointer}.card-selected[_ngcontent-%COMP%]{background:#44a38b !important}.card-unselected[_ngcontent-%COMP%]{background:#fff}.text-selected[_ngcontent-%COMP%]{color:#fff}.text-unselected[_ngcontent-%COMP%]{color:#44a38b}.header[_ngcontent-%COMP%]{color:var(--Text-Dark-Green, #0A4A3A);font-family:Poppins,serif;font-size:18px;font-style:normal;font-weight:600;line-height:130%}.text[_ngcontent-%COMP%]{color:var(--Text-Dark-Green, #0A4A3A);text-align:center;font-feature-settings:\"clig\" off,\"liga\" off;font-family:Open Sans,serif;font-size:12px;font-style:normal;font-weight:400;line-height:140%}.main-body[_ngcontent-%COMP%]{padding:30px 30px 20px 30px}.close[_ngcontent-%COMP%]{color:gray;font-size:20px;cursor:pointer;padding:10px}.modal-body[_ngcontent-%COMP%]{padding:0}button[_ngcontent-%COMP%]{margin:5px;height:36px}.btn[_ngcontent-%COMP%]{padding-left:0;padding-right:0}.btn-primary[_ngcontent-%COMP%]{width:150px}.btn-secondary[_ngcontent-%COMP%]{width:76px;min-width:70px}.skip-link[_ngcontent-%COMP%]{text-decoration:underline;border:none;color:#9db7b0}[_nghost-%COMP%]  .is-match-with-coach .mat-form-field-infix{width:280px !important}  .tool-tip{color:#fff !important;background:#44a38b !important;border:1px solid #44a38b !important;overflow:visible !important}  .tool-tip:before{content:\"\";position:absolute;top:100%;left:40%;border-top:5px solid #44a38b;border-left:5px solid transparent;border-right:5px solid transparent;z-index:10000}@media(min-width: 576px){[_nghost-%COMP%]  .is-match-with-coach .mat-form-field-infix{width:440px !important}.header[_ngcontent-%COMP%]{color:var(--Text-Dark-Green, #0A4A3A);font-family:Poppins,serif;font-size:26px;font-style:normal;font-weight:700;line-height:140%}.text[_ngcontent-%COMP%]{color:var(--Dark-Text, #0A4A3A);text-align:center;font-family:Open Sans,serif;font-size:16px;font-style:normal;font-weight:400;line-height:140%}}@media(min-width: 768px){.grid-container-xl[_ngcontent-%COMP%]{display:grid;grid-gap:20px !important;max-width:620px !important;margin:auto}.language-card[_ngcontent-%COMP%]{width:140px !important}}"] });
